import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router';
import { selectedDateWithoutTime } from '@store/global/selectors';
import { selectValidParams, selectDateRange, selectGridData } from '@pages/reporting-pages/deliveries-sku-district/store/selectors';
import { SkuDistrictParams } from '@api/order-reporting/types-deliveries/DeliveriesParams';
import { setSearchParameters, setDateRange } from '@pages/reporting-pages/deliveries-sku-district/store/slice';
import { DateRange } from '@project-types/DateRange';
import { useResetDeliveriesSkuDistrictMutation } from '@api/order-reporting/deliveryApi';
import { AppPage } from 'components/app-page/AppPage';
import ParamsToolbar from '@pages/reporting-pages/deliveries-sku-district/params-toolbar/ParamsToolbar';
import Grid from '@pages/reporting-pages/deliveries-sku-district/grid/Grid';
import { headersObject } from '@pages/reporting-pages/deliveries-sku-district/headersObject';



const DeliveriesSkuDistrict = () => {

	const validParams = useSelector(selectValidParams);
	const dateWithoutTime = useSelector(selectedDateWithoutTime);
	const dateRange = useSelector(selectDateRange);
	const gridData = useSelector(selectGridData);

	const [ search, setSearch ] = useSearchParams();
	const dispatch = useDispatch();
	const updateSearchParameters = (parameters: SkuDistrictParams) => dispatch(setSearchParameters(parameters));
	const updateDateRange = (dateRange: DateRange) => dispatch(setDateRange(dateRange));

	const [ runReset ] = useResetDeliveriesSkuDistrictMutation();


	useEffect(() => {
		if (!dateRange) {
			updateDateRange({ from: dateWithoutTime, to: dateWithoutTime });
		}
	}, []);

	
	useEffect(() => {
		if (validParams) {
			setSearch({ ...validParams }, { replace: true });
		}
	}, [ validParams ]);

	
	useEffect(() => {
		if (search) {
			let paramDateFrom = search.get('dateFrom');
			let paramDateTo = search.get('dateTo');
			let paramMaterialId = search.get('materialId');

			if (!paramDateFrom || !paramDateTo || !paramMaterialId) return;

			let newSearchParams: SkuDistrictParams = {
				dateFrom: paramDateFrom,
				dateTo: paramDateTo,
				materialId: paramMaterialId,
			}
			updateSearchParameters(newSearchParams);
		}
	}, [ search ]);


	const resetAllApi = useCallback(() => {
		runReset();
	},[]);


	return (
		<AppPage
			className='reporting-page deliveries-sku-district'
			pageLabel='Report dodávek - Sku District'
			resetPageApi={resetAllApi}
			csvData={{
				headers: headersObject,
				data: gridData,
				filename: 'reporting-dodavky-sku-district'
			}}
		>
			<ParamsToolbar />
			<Grid />
		</AppPage>
	)
};

export default DeliveriesSkuDistrict;